import { render, staticRenderFns } from "./overSeasExceptionOrder.vue?vue&type=template&id=34327d1a&scoped=true&"
import script from "./overSeasExceptionOrder.vue?vue&type=script&lang=js&"
export * from "./overSeasExceptionOrder.vue?vue&type=script&lang=js&"
import style0 from "./overSeasExceptionOrder.vue?vue&type=style&index=0&id=34327d1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34327d1a",
  null
  
)

component.options.__file = "overSeasExceptionOrder.vue"
export default component.exports